module.exports = __webpack_public_path__ + "images/tongue-out.png";